import { SideBarNotification } from "@app/core/models/side-bar-notification/side-bar-notification";
import { createAction, props } from "@ngrx/store";

export const getSideBarNotificationList = createAction("[Notifications] Get Side Bar Notification List");
export const getSideBarNotificationListSuccess = createAction("[Notifications] Get Side Bar Notification List Success", props<{ payload: SideBarNotification[] }>());
